// This file is auto-generated. Do not edit manually.
export const versionInfo = {
  "version": "2.12.0",
  "lastUpdated": "May 28, 2026",
  "buildDate": "2026-06-05T04:09:43.255Z"
};
